(function () {
  const { searchPath, isSearchPage } = window.bogartSearchConfig;

  // Convert bookmarks from the former title/tag search to ordinary Shopify queries.
  function searchQuery(value) {
    const query = value.trim();
    const combined = query.match(/^(?:\(.*\)) OR tag:"([^"\\]+)"$/u);
    if (combined) return combined[1];
    if (/^title:"[^"]+"(?:\s+title:"[^"]+")*$/.test(query)) {
      return Array.from(query.matchAll(/title:"([^"]+)"/g), match => match[1]).join(' ');
    }
    return query;
  }

  window.bogartSearchQuery = searchQuery;

  function exactSearchQuery(value) {
    const query = searchQuery(value);
    if (!query) return '';
    // A phrase search is resolved in Shopify's index, without scanning variants in Liquid.
    return /^"(?:[^"\\]|\\.)*"$/u.test(query) ? query : JSON.stringify(query);
  }

  document.addEventListener('formdata', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || new URL(form.action).pathname !== searchPath) return;
    const query = event.formData.get('q');
    if (typeof query === 'string') event.formData.set('q', exactSearchQuery(query));
  }, true);

  if (isSearchPage) {
    const url = new URL(window.location.href);
    const query = url.searchParams.get('q');
    if ((query && exactSearchQuery(query) !== query) || url.searchParams.has('title_fallback')) {
      if (query) url.searchParams.set('q', exactSearchQuery(query));
      url.searchParams.delete('title_fallback');
      window.location.replace(url.href);
    }
  }
})();
